import cookies from 'js-cookie';
import config from '../../app-config';
import { AUTH_TOKEN } from '../constants-togather/auth';

export const storeToken = (token) => {
  cookies.set(AUTH_TOKEN, token, {
    ...(config.cookieSecure && { secure: config.cookieSecure }),
    expires: 21,
  });
};
